module.exports = __webpack_public_path__ + "static/media/workspace_1.f8f31299.png";